var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "imageMessage" },
      on: {
        mouseenter: function ($event) {
          _vm.hovered = true
        },
        mouseleave: function ($event) {
          _vm.hovered = false
        },
      },
    },
    [
      _c(
        "viewer",
        {
          attrs: {
            id: "imageViewer-" + _vm.message.raw.asset._id,
            images: [_vm.imageSrc()],
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "cb-img-preview",
              attrs: { content: _vm.$t("chatbot.imageView") },
              on: { click: _vm.show },
            },
            [
              _c("img", {
                staticClass:
                  "img-thumbnail ant-upload-list-picture-card-container",
                staticStyle: { "object-fit": "cover" },
                attrs: {
                  id: "img-" + _vm.message.raw.asset._id,
                  src: _vm.imageSrc(),
                },
              }),
              _vm._v(" "),
              _vm.hovered
                ? _c(
                    "md-icon",
                    { staticClass: "cb-pr-icon", on: { click: _vm.show } },
                    [_vm._v(" visibility ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }